import React, { FC } from "react";
import { Flex, Tooltip } from "@evergis/ui";

import { LayerStatisticsValuePlaceholder, PlaceholderShining } from "./styled";

export const ValuePlaceholder: FC<{ error?: boolean }> = ({ error }) => {
  return (
    <Flex style={{ width: "7rem", position: "relative", overflow: "hidden", borderRadius: "0.375rem" }}>
      {error ? (
        <Tooltip content="Не удалось получить данные">{ref => <LayerStatisticsValuePlaceholder ref={ref} />}</Tooltip>
      ) : (
        <LayerStatisticsValuePlaceholder />
      )}
      {!error && <PlaceholderShining height="0.75rem" />}
    </Flex>
  );
};
